import {defineStore} from "pinia";

interface LocaleTexts {
    [key: string]: string
}

interface LocaleState {
    texts: LocaleTexts
    language: string
}

const texts: LocaleTexts = {
    withdrawal_form_title: 'Formulár na odstúpenie od zmluvy',
    withdrawal_form_description: '(vyplňte a zašlite tento formulár len v prípade, že si želáte odstúpiť od zmluvy)',
    withdrawal_store_address: 'CBC Slovakia s.r.o., Galvaniho 7/B, 82104 Bratislava, IČO: 44773293, email: dispecing@cbcslovakia.sk, telefón +421 850 11 15 15',
    withdrawal_full_name: 'Meno a priezvisko',
    withdrawal_address_street: 'Ulica a číslo domu',
    withdrawal_address_city: 'Mesto',
    withdrawal_address_zip: 'PSČ',
    withdrawal_email: 'E-mail',
    withdrawal_phone: 'Telefónne číslo',
    withdrawal_order_id: 'Číslo objednávky',
    withdrawal_order_date: 'Dátum vytvorenia objednávky',
    withdrawal_delivery_date: 'Dátum doručenia objednávky',
    withdrawal_iban: 'Číslo bankového účtu pre vrátenie sumy (IBAN)',
    withdrawal_description: 'Identifikácia a popis zakúpeného tovaru',
    withdrawal_instructions_title: 'Poučenie',
    withdrawal_submit: 'Odoslať formulár',
    withdrawal_success_title: 'Formulár bol úspešne odoslaný',
    withdrawal_success_description: 'Ďakujeme za vyplnenie formulára. Vaše údaje sme prijali a budeme Vás kontaktovať.',
    withdrawal_instructions_content: `<p><strong>1. Právo na odstúpenie od kúpnej zmluvy</strong></p><p>Ak nakupujete ako spotrebiteľ, máte právo odstúpiť od tejto kúpnej zmluvy bez uvedenia dôvodu v lehote <strong>14 dní od prevzatia tovaru</strong>. Lehota na odstúpenie od zmluvy uplynie po 14 dňoch odo dňa keď Vy alebo Vami určená tretia osoba s výnimkou dopravcu prevezmete tovar, resp. odo dňa uzavretia zmluvy o poskytnutí služby alebo odo dňa uzavretia zmluvy o dodaní digitálneho obsahu inak ako na hmotnom nosiči. Lehota na odstúpenie od zmluvy je zachovaná, ak zašlete oznámenie o uplatnení práva na odstúpenie od kúpnej zmluvy predtým, ako uplynie lehota na odstúpenie od zmluvy. Ak je predmetom kúpnej zmluvy kúpa tovaru, môžete od kúpnej zmluvy odstúpiť aj pred začatím plynutia lehoty na odstúpenie od zmluvy.</p><p><strong>2. Dôsledky odstúpenia od zmluvy</strong></p><p>Po odstúpení Vám vrátime všetky platby, ktoré ste uhradili v súvislosti s uzavretím kúpnej zmluvy, najmä kúpnu cenu vrátane nákladov na doručenie tovaru k Vám. To sa nevzťahuje na dodatočné náklady, ak ste si zvolili iný druh doručenia, ako je najlacnejší bežný spôsob doručenia, ktorý ponúkame ani na náklady za doplnkové služby, ak boli predmetom zmluvy a ak došlo k ich úplnému poskytnutiu. <strong>Platby Vám budú vrátené</strong> bez zbytočného odkladu a v každom prípade najneskôr <strong>do</strong> <strong>14 dní</strong> odo dňa, keď nám bude doručené Vaše oznámenie o odstúpení od tejto kúpnej zmluvy. Úhrada bude uskutočnená rovnakým spôsobom, aký ste použili pri Vašej platbe, pokiaľ ste uvedením IBAN čísla Vášho bankového účtu nedali súhlas s úhradou na Váš bankový účet a to bez účtovania akýchkoľvek ďalších poplatkov.<br>S vrátením platby <strong>môžeme čakať do vrátenia tovaru</strong> späť na našu adresu, alebo do preukázania, že ste tovar odoslali späť, podľa toho, čo nastane skôr. <strong>Zašlite nám tovar späť</strong> alebo ho prineste na adresu sídla spoločnosti bez zbytočného odkladu a v každom prípade najneskôr <strong>do 14 dní odo dňa uplatnenia práva na odstúpenie od zmluvy</strong>. Priame náklady na vrátenie tovaru znášate Vy.<br>Upozorňujeme Vás, že v prípade odstúpenia od kúpnej zmluvy <strong>zodpovedáte</strong> v zmysle zákona <strong>za</strong> akékoľvek <strong>zníženie hodnoty tovaru</strong> v dôsledku zaobchádzania s ním v čase od jeho prevzatia do momentu jeho vrátenia iným spôsobom, než aký je potrebný na zistenie povahy, vlastností a funkčnosti tovaru. Ak ste požiadali o <strong>začatie poskytovania služby</strong> počas lehoty na odstúpenie od zmluvy, máte povinnosť <strong>uhradiť nám cenu za skutočne poskytnuté plnenie</strong> do dňa, kedy ste nám oznámili Vaše rozhodnutie odstúpiť od tejto zmluvy.</p><p></p>`,
    withdrawal_return_method: 'Spôsob vrátenia tovaru',
    withdrawal_return_store: 'Vrátim do predajne',
    withdrawal_return_courier: 'Zašlem kuriérom',
    withdrawal_return_other: 'Iné',
    withdrawal_return_branch: 'Predajňa',
    withdrawal_return_desc: 'Popis spôsobu vrátenia',
    withdrawal_is_partial: 'Rozsah odstúpenia',
    withdrawal_partial: 'Chcem vrátiť časť objednávky',
    withdrawal_not_partial: 'Chcem vrátiť celú objednávku',
    withdrawal_items: 'Položky objednávky:',
    withdrawal_item_add: 'Pridať položku',
    withdrawal_product_id: 'Číslo produktu',
    withdrawal_product_name: 'Názov produktu',
    withdrawal_product_quantity: 'Počet',
    withdrawal_product_note: 'Popis',
}

export function useLocaleStore() {

    const store = defineStore('l10n', {

        state: (): LocaleState => ({
            texts,
            language: 'sk'
        }),

        actions: {
            getText(key: string): string {
                return this.texts[key] ?? `{${key}}`
            }
        }

    })

    return store()

}
